import React from 'react';

import './home-marketing-area-card.scss';

export const HomeMarketingAreaCard = () => {
  return <div className='home-marketing-area-card'>
    <div className='home-marketing-area-card-image'/>
  </div>;
};
